module.exports = __webpack_public_path__ + "static/stripe-left.713f59bb.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/stripe-left.png
// module id = 1054
// module chunks = 2